import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Signout = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 2H7C5.3 2 4 3.3 4 5V11H12.6L10.3 8.7C9.9 8.3 9.9 7.7 10.3 7.3C10.7 6.9 11.3 6.9 11.7 7.3L15.7 11.3C16.1 11.7 16.1 12.3 15.7 12.7L11.7 16.7C11.3 17.1 10.7 17.1 10.3 16.7C9.9 16.3 9.9 15.7 10.3 15.3L12.6 13H4V19C4 20.7 5.3 22 7 22H17C18.7 22 20 20.7 20 19V5C20 3.3 18.7 2 17 2Z"
      fill="currentColor"
    />
  </svg>
)

export default Signout
